import React, { use, useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import Sidebar from "../SideBar/SideBar";
import usercalls from "../../Axios";
import {
  Box,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  Grid,
  TablePagination,
  TableRow,
  TableCell,
  Tooltip,
  TableHead,
  TableContainer,
  Table,
  TableBody,
  Button,
  ListSubheader,
  CircularProgress,
} from "@mui/material";
import nodata from "../../Img/newnodta.gif";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { useQuery } from "react-query";
import "./instant.scss";
import consts from "../../constant";
import transakSDK from "@transak/transak-sdk";
import { set, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast, { Toaster } from "react-hot-toast";
import Footernew from "../Footer/Footernew";
import { useUserData } from "../../Contexts/UserContext";
import WertWidget from "@wert-io/widget-initializer";
import axios from "axios";
import { io } from "socket.io-client";

// Utility function for debouncing
// export function Debounce(value, delay = 300) {
//   const [debouncedValue, setDebouncedValue] = useState(value);

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedValue(value);
//     }, delay);

//     return () => clearTimeout(handler); // cleanup on unmount or value change
//   }, [value, delay]);

//   return debouncedValue;

// }

export default function Instant() {
  const [coin, setCoin] = useState("usdt");
  const [coin1, setCoin1] = useState("eur");
  const [feeAmount, setFeeAmount] = useState(0);
  const path = usercalls();
  const [abvcoin, setabvCoin] = useState("12");
  const [blwcoin, setblwCoin] = useState("dfdfdf");
  const { userData } = useUserData();
  const [submitLoading, setSubmitLoading] = useState(false);
  // const handleChangeCoin = (event) => {
  //   setSelectedTopCoin(event.target.value);
  // };
  const schema = yup.object().shape({
    fiatAmount: yup.number().typeError("Enter valid Number"),
  });

  const {
    register,
    reset,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const handleSwapCoins = () => {
    setabvCoin(coin1);
    setblwCoin(coin);
  };

  const [selectedTopCoin, setSelectedTopCoin] = useState("select");
  const [selectedBottomCoin, setSelectedBottomCoin] = useState("select");

  const [topCoinBalance, setTopCoinBalance] = useState(0);
  const [bottomCoinBalance, setBottomCoinBalance] = useState(0);

  const [cryptoDetails, setCryptoDetails] = useState({});
  const [upperPairList, setUpperPairList] = useState([]);
  const [lowerPairList, setLowerPairList] = useState([]);

  const [networks, setNetworks] = useState("");
  const [assets, setAssets] = useState("");

  const [fiatAmount, setFiatAmount] = useState("");
  const [cryptoAmount, setCryptoAmount] = useState("");

  const [instantBuySell, setInstantBuySell] = useState({});
  const [search, setSearch] = useState("");
  const [search1, setSearch1] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page

  const navigate = useNavigate();

  const openWidget = async () => {
    let widget = null;
    try {
      if (submitLoading) return;
      if (selectedTopCoin === "select") {
        toast.error("Please select a currency");
        return;
      } else if (fiatAmount === "" || Number(fiatAmount) < 5) {
        toast.error("Please enter a valid payment amount, minimum is 5");
        return;
      } else if (selectedBottomCoin === "select") {
        toast.error("Please select a currency");
        return;
      }
      setSubmitLoading(true);
      const url = `${consts.BackendUrl}/wallet/create-session`;
      const payload = {
        currency: selectedTopCoin,
        crypto: cryptoDetails.symbol,
        network: cryptoDetails.network,
        type: cryptoDetails.chain_type ? cryptoDetails.chain_type : "evm",
        amount: Number(fiatAmount),
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        const options = {
          partner_id: consts.wert_partner_id,
          session_id: result?.result?.session_id,
          click_id: result?.result?.click_id,
          origin: "https://widget.wert.io",
        };
        widget = new WertWidget(options);
        widget.addEventListeners({
          close: () => {
            setSubmitLoading(false);
            getInstantBuySell();
          },
          loaded: () => {
            widget.updateTheme({
              theme: localStorage.getItem("theme") === "dark" ? "dark" : "light",
            });
            setSubmitLoading(false);
          },
        })
        widget.open();
      } else {
        setSubmitLoading(false);
        toast.error(result?.message);
      }
    } catch (e) {
      setSubmitLoading(false);
      console.log(e, "Error");
    }
  };

  const getFiatData = async () => {
    try {
      const url = `${consts.BackendUrl}/getfiatcurrency`;
      const response = await path.getCallWithToken({ url });
      const result = await response.json();
      if (result?.success) {
        if (result?.result?.length > 0) {
          const combinedAssets = new Set();
          result?.result?.forEach((pair) => {
            combinedAssets.add(pair.symbol?.toUpperCase());
            // combinedAssets.add(pair.market_asset_name?.toUpperCase());
          });
          // setUpperPairList(Array.from(combinedAssets));
          setUpperPairList(result.result);
        }
      } else {
        // console.log(result?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const socket = io(consts?.socketUrl, {
      path: "/socket",
    });

    socket.on("connect", () => {
      socket.emit("join", {
        room: localStorage.getItem("use"),
      });
      console.log("Connected to socket");
    });

    socket.on("wertOrder", (data) => {
      console.log(data, "wertOrder");
      if (data?.success) {
        setInstantBuySell(data?.result);
      } else {
        getInstantBuySell();
      }
    });

    return () => {
      socket.off("wertOrder");
      socket.disconnect();
    };
  }, []);

  // Debounced function
  // const debouncedSubmit = useCallback(
  //   debounce((value) => {
  //     getPrice();
  //   }, 300), // 300ms debounce delay
  //   []
  // );
  // const debouncedValue = Debounce(fiatAmount)

  // Effect to call debounced function when search changes
  // useEffect(() => {
  //   if (debouncedValue) {
  //     getPrice(debouncedValue);
  //   }

  // }, [debouncedValue]);
  const getCurrencyList = async () => {
    try {
      const url = `${consts.BackendUrl}/wallet/get-currency-list`;
      const response = await path.getCallWithToken({ url });
      const result = await response.json();
      if (result?.success) {
        if (result?.result?.length > 0) {
          setLowerPairList(result.result);
        } else {
          setLowerPairList([]);
        }
      } else {
        setUpperPairList([]);
        // console.log(result?.message);
      }
    } catch (error) {
      setLowerPairList([]);
      console.log(error);
    }
  };
  // const getCryptoData = async () => {
  //   try {
  //     const url = `${consts.BackendUrl}/getcryptocurrency`;
  //     const response = await path.getCallWithToken({ url });
  //     const result = await response.json();
  //     if (result?.success) {
  //       if (result?.result?.length > 0) {
  //         var network = new Set()
  //         var asset = new Set()
  //         result.result.forEach((pair) => {
  //           // combinedAssets.symbol = pair.symbol;
  //           // combinedAssets.name = pair.name;
  //           // combinedAssets.network = pair.network.name;
  //           // console.log(pair)
  //           // combinedAssets.add(pair.market_asset_name?.toUpperCase());
  //           network.add(pair.network.name);
  //           asset.add(pair.symbol?.toUpperCase());
  //           setLowerPairList((pre) => [...pre, pair]);
  //         });

  //         console.log(network, asset, "network")
  //         const results = [...network].join(",");
  //         setNetworks(results)
  //         const assets = [...asset].join(",");
  //         setAssets(assets)
  //       }
  //     } else {
  //       // console.log(result?.message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const { data: pairs, error: pairserror, isLoading: pairsloading } = useQuery({
  //   queryKey: ['Fiat'],
  //   queryFn: getFiatData,
  //   refetchOnWindowFocus: false, // Prevent refetching when window gains focus
  //   retry: 0,
  // });

  // const { data: crypto, error: cryptoerror, isLoading: cryptoloading } = useQuery({
  //   queryKey: ['Crypto'],
  //   queryFn: getCryptoData,
  //   refetchOnWindowFocus: false, // Prevent refetching when window gains focus
  //   retry: 0,
  // });

  useEffect(() => {
    getFiatData();
    // getCryptoData();
    getCurrencyList();
    getInstantBuySell();
  }, []);
  // console.log(lowerPairList)

  const handleTopCoinChange = (event) => {
    setSearch("");
    const selectedCoin = event.target.value;
    setSelectedTopCoin(selectedCoin);
    setFiatAmount("");
    setSelectedBottomCoin("select"); // Reset bottom coin when top coin changes

    // getBalanceByPair(selectedCoin, 'top');
  };

  // const getPrice = async (amt) => {
  //   try {
  //     console.log(fiatAmount)
  //     const url = `https://api-stg.transak.com/api/v1/pricing/public/quotes?partnerApiKey=5b5bbbe9-6cf9-4f41-9a3a-9d796622d83a&fiatCurrency=${selectedTopCoin}&cryptoCurrency=${cryptoDetails?.symbol}&isBuyOrSell=BUY&network=${cryptoDetails?.network?.name}&paymentMethod=credit_debit_card&fiatAmount=${amt}`;
  //     const response = await path.getCall({ url });
  //     const result = await response.json();
  //     console.log(result)
  //     if (result.error) {
  //       setError('fiatAmount', { message: result.error.message });
  //     } else {
  //       clearErrors();
  //       setCryptoAmount(result?.response?.cryptoAmount)
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const getInstantBuySell = async () => {
    try {
      // const url = `${consts.BackendUrl}/getinstantbuysell?page=${page + 1
      //   }&limit=${rowsPerPage}`;
      const url = `${consts.BackendUrl}/get-instatant-orders?page=${page + 1}&limit=${rowsPerPage}`;
      const payload = {};
      console.log(payload, "payload get data")
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      // console.log(result)
      if (result.success) {
        setInstantBuySell(result?.result);
      } else {
        setInstantBuySell({});
        // toast.error(result.message);
      }
    } catch (error) {
      setInstantBuySell({});
      console.log(error);
    }
  };

  const handleChangeCoin1 = (event) => {
    setSearch1("");
    setSelectedBottomCoin(event.target.value);
    setCryptoDetails(
      lowerPairList.find((cry) => cry._id === event.target.value),
    );
    // getPrice();
  };

  // const handleFiatAmountChange = (e) => {
  //   setFiatAmount(e.target.value);
  //   // getPrice();
  // }
  // console.log(cryptoDetails)

  // 👇 Module or component top-level
  let transak = null;
  const processedOrder = useRef(new Set());

  const openTransak = async () => {
    if (transak) {
      transak.init(); // If already created, just re-init
      return;
    }

    const url = `${consts.BackendUrl}/wallet/getAddress`;
    const payload = { type: cryptoDetails?.network?.name };
    const response = await path.postCall({ url, payload });
    const result = await response.json();
    var address = "";
    if (result?.result) {
      console.log(result?.result, "ajiofjosi");
      address = result?.result;
    }

    // console.log(networks, assets, cryptoDetails?.network?.name, "cryptoDetails")
    transak = new transakSDK({
      apiKey: "6189f285-8e23-4cfc-8571-9c79240833bb",
      environment: "PRODUCTION", // STAGING or PRODUCTION
      widgetHeight: "600px",
      widgetWidth: "500px",
      defaultFiatCurrency: "EUR",
      fiatCurrency: selectedTopCoin,
      defaultNetwork: cryptoDetails?.network?.name || "bsc",
      defaultCryptoCurrency: cryptoDetails?.symbol,
      productsAvailed: "BUY",
      networks: networks,
      cryptoCurrencyList: assets,
      disableCryptoCurrencyChange: true,
      hideMenu: true,
      walletAddress: address,
    });

    transak.init();

    transak.on(transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, (orderData) => {
      if (processedOrder.current.has(orderData.id)) {
        return; // Skip if already processed
      }
      processedOrder.current.add(orderData.id);
      createOrder(orderData.status);
      transak.close();
      document.body.style.overflow = "auto";
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const createOrder = async (data) => {
    try {
      const url = `${consts.BackendUrl}/createinstantbuysell`;
      const payload = { order: data };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        toast.success("Order successfull");
        getInstantBuySell();
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const getBalanceByPair = async (pair, type) => {
  //   try {
  //     const url = `${consts.BackendUrl}/getwalletusingpair`;
  //     const response = await path.postCall({ url, payload: { asset_name: pair } });
  //     const result = await response.json();
  //     console.log(result, "result")
  //     if (result?.result) {
  //       if (type == 'top') {
  //         setTopCoinBalance(result.result.balance);
  //       }
  //     }

  //   } catch (error) {
  //     console.log(error, "error")
  //   }
  // }
  const calculateReceiveAmount = async () => {
    try {
      if (selectedBottomCoin !== "select" && selectedTopCoin !== "select") {
        const payload = {
          from: selectedTopCoin,
          to: cryptoDetails?.symbol,
          network: cryptoDetails?.network,
          amount: Number(fiatAmount),
        };
        const { data } = await axios.post(
          "https://widget.wert.io/api/v3/partners/convert",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              "x-partner-id": consts.wert_partner_id,
            },
          },
        );
        if (data?.status === "ok") {
          const rawAmount = data?.body?.commodity_amount;

          const cryptoAmount =
            rawAmount !== undefined && rawAmount !== null && !isNaN(rawAmount)
              ? parseFloat(Number(rawAmount).toFixed(8))
              : 0;
          const feeAmount = data?.body?.miner_fee;

          const fee =
            feeAmount !== undefined && feeAmount !== null && !isNaN(feeAmount)
              ? parseFloat(Number(feeAmount).toFixed(8))
              : 0;
          setFeeAmount(fee);
          setCryptoAmount(cryptoAmount);
        }
      } else {
        setCryptoAmount(0);
        setFeeAmount(0);
      }
    } catch (e) {
      console.log(e, "error");
      setFeeAmount(0);
      setCryptoAmount(0);
    }
  };
  useEffect(() => {
    const timer = setTimeout(calculateReceiveAmount, 500);
    return () => clearTimeout(timer);
  }, [selectedBottomCoin, fiatAmount]);

  const handleSubmit = () => {
    if (selectedTopCoin === "select" || selectedBottomCoin === "select") {
      toast.error("Please select Currency");
    } else {
      openTransak();
    }
  };

  useEffect(() => {
    if (userData?.kyc_verify == "false") {
      navigate("/kycverify");
      toast.error("Verify KYC to Buy Crypto");
    }
  }, [userData]);

  return (
    <div>
      <Header />
      <div className="main_flx">
        <Sidebar />
        <div style={{ width: "100%" }}>
          <div className="abvbar split_half">
            <h6>Instant</h6>
          </div>
          <div className="split_half mt-30">
            <Grid
              container
              spacing={5}
            // justifyContent={"center"}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                xl={6}
                className="grid-margin"
              >
                <div className="box_bdr">
                  <h2>Sell Crypto</h2>
                  <h5 style={{ margin: "0", marginBottom: "10px" }}>Spend</h5>
                  {/* <div style={{ textAlign: "right" }}>
                    <p className="mb-10">Balance:</p>
                    <p className="mt-10">{topCoinBalance} {selectedTopCoin == "select" ? "" : selectedTopCoin}</p>
                  </div> */}
                  <div className="input_box in_sele">
                    {/* <TextField
                      fullWidth
                      type="number"
                      placeholder="0.00"
                      {...register('fiatAmount')}
                      error={errors.fiatAmount}
                      helperText={errors.fiatAmount?.message}
                      value={fiatAmount}
                      onChange={(e) => {
                        setFiatAmount(e.target.value);
                        getPrice(e.target.value);
                      }}
                      sx={{
                        borderRadius: "5px",
                        "& .MuiInputBase-formControl": { borderRadius: "5px" },
                        "& .MuiInputBase-input": { padding: "11px  0 11px 0px", border: "0" },
                        "& fieldset": { border: "1px solid #d3d1d1 !important" },
                        "& .MuiInputBase-input::placeholder": { color: "black", fontSize: "15px" },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"> */}
                    {/*                             
                          </InputAdornment>
                        ),
                      }}
                    /> */}
                    <FormControl fullWidth>
                      <Select
                        className="bord-li"
                        value={selectedTopCoin ? selectedTopCoin : "selectCoin"}
                        onChange={handleTopCoinChange}
                        sx={{
                          "& .MuiInputBase-formControl": {
                            borderRadius: "5px",
                          },
                          "& .MuiInputBase-input": {
                            padding: "11px ",
                            border: "0",
                          },
                          "& fieldset": {
                            border: "0px solid #d3d1d1 !important",
                          },
                          "& MuiMenu-list": {
                            maxWidth: "200px",
                            overflow: "scroll",
                          },
                        }}
                      >
                        <ListSubheader
                          sx={{
                            backgroundColor: "var(--mui-select-bg) !important",
                            zIndex: 10,
                            position: "sticky",
                            top: "-10px",
                            paddingTop: "10px",
                          }}
                        >
                          <TextField
                            className="transfer-search"
                            size="small"
                            placeholder="Search..."
                            fullWidth
                            autoFocus
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={(e) => e.stopPropagation()}
                          />
                        </ListSubheader>
                        <MenuItem value="select" disabled={true}>
                          Select Coin
                        </MenuItem>
                        {upperPairList
                          ?.filter((item) =>
                            item?.symbol
                              ?.toLowerCase()
                              ?.includes(search?.toLowerCase())
                          )
                          ?.map((e) => (
                            <MenuItem value={e.symbol}>
                              <div className="display-1 no-marg">
                                <img
                                  src={`data:image/svg+xml;utf8,${encodeURIComponent(
                                    e.icon,
                                  )}`}
                                  width={30}
                                  height={30}
                                  alt="symbol"
                                />
                                <p>{e.symbol}</p>
                                <p>({e.name})</p>
                              </div>
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                  <h5 style={{ margin: "0", margin: "15px 0 10px 0" }}>
                    Amount to Pay
                  </h5>
                  <div className="input_box in_sele">
                    <TextField
                      fullWidth
                      type="number"
                      placeholder="0.00"
                      value={fiatAmount}
                      sx={{
                        borderRadius: "5px",
                        "& .MuiInputBase-formControl": { borderRadius: "5px" },
                        "& .MuiInputBase-input": {
                          padding: "11px  0 11px 0px",
                          border: "0",
                        },
                        "& fieldset": {
                          border: "1px solid #d3d1d1 !important",
                        },
                        "& .MuiInputBase-input::placeholder": {
                          color: "black",
                          fontSize: "15px",
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                      onChange={(e) => setFiatAmount(e.target.value)}
                    />
                  </div>
                  <div
                    className="display-3 swap_icon"
                    onClick={() => {
                      handleSwapCoins();
                    }}
                  >
                    <SwapVertIcon />
                  </div>

                  <h5 style={{ margin: "0", marginBottom: "10px" }}>Receive</h5>
                  {/* <div style={{ textAlign: "right" }}>
                    <p className="mb-10">Balance:</p>
                    <p className="mt-10">{bottomCoinBalance} {selectedBottomCoin === "select" ? "" : selectedBottomCoin}</p>
                  </div> */}
                  <div className="input_box in_sele">
                    {/* <TextField
                      fullWidth
                      type="number"
                      placeholder="0.00"
                      value={cryptoAmount}
                      sx={{
                        borderRadius: "5px",
                        "& .MuiInputBase-formControl": { borderRadius: "5px" },
                        "& .MuiInputBase-input": { padding: "11px  0 11px 0px", border: "0" },
                        "& fieldset": { border: "1px solid #d3d1d1 !important" },
                        "& .MuiInputBase-input::placeholder": { color: "black", fontSize: "15px" },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"> */}
                    {/*                             
                          </InputAdornment>
                        ),
                      }}
                    /> */}
                    <FormControl fullWidth>
                      <Select
                        className="bord-li"
                        value={selectedBottomCoin}
                        onChange={handleChangeCoin1}
                        sx={{
                          "& .MuiInputBase-formControl": {
                            borderRadius: "5px",
                          },
                          "& .MuiInputBase-input": {
                            padding: "11px ",
                            border: "0",
                          },
                          "& fieldset": {
                            border: "0px solid #d3d1d1 !important",
                          },
                        }}
                      >
                        <ListSubheader
                          sx={{
                            backgroundColor: "var(--mui-select-bg) !important",
                            zIndex: 10,
                            position: "sticky",
                            top: "-10px",
                            paddingTop: "10px",
                          }}
                        >
                          <TextField
                            className="transfer-search"
                            size="small"
                            placeholder="Search..."
                            fullWidth
                            autoFocus
                            onChange={(e) => setSearch1(e.target.value)}
                            onKeyDown={(e) => e.stopPropagation()}
                          />
                        </ListSubheader>
                        <MenuItem value="select" disabled={true}>
                          Select Coin
                        </MenuItem>
                        {lowerPairList
                          ?.filter((item) =>
                            item?.symbol
                              ?.toLowerCase()
                              ?.includes(search1?.toLowerCase()),
                          )
                          ?.map((e) => (
                            <MenuItem value={e._id}>
                              <div className="display-1 no-marg">
                                {/* <img
                                  src={e.image.thumb}
                                  width={30}
                                  height={30}
                                  alt="symbol"
                                /> */}
                                <p>{e?.symbol}</p>
                                <p>({e?.network?.toUpperCase()})</p>
                              </div>
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                  <h5 style={{ margin: "0", margin: "20px 0 10px 0" }}>
                    Amount to Receive
                  </h5>
                  <div style={{ textAlign: "right" }}>
                    <p className="mb-10">Fee Amount: {feeAmount || 0}</p>
                  </div>
                  <div className="input_box in_sele">
                    <TextField
                      fullWidth
                      type="number"
                      placeholder="0.00"
                      value={cryptoAmount}
                      sx={{
                        borderRadius: "5px",
                        "& .MuiInputBase-formControl": { borderRadius: "5px" },
                        "& .MuiInputBase-input": {
                          padding: "11px  0 11px 0px",
                          border: "0",
                        },
                        "& fieldset": {
                          border: "1px solid #d3d1d1 !important",
                        },
                        "& .MuiInputBase-input::placeholder": {
                          color: "black",
                          fontSize: "15px",
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                    // onChange={(e) => setCryptoAmount(e.target.value)}
                    />
                  </div>
                  {/* <div className="fee_box">
                    <div>
                      <div>Fee Percentage:</div>
                      <div>0</div>
                    </div>
                    <div>
                      <div>Sell Crypto Fee:</div>
                      <div>0 EUR</div>
                    </div>
                  </div> */}

                  <Link
                    to="#"
                    onClick={openWidget}
                    className="org_btn sm_txt"
                    disabled={submitLoading}
                    style={{
                      padding: "12px 60px",
                      margin: "20px 0 0",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    {submitLoading && <CircularProgress size={20} color="inherit" />} Convert
                  </Link>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-margin"
              >
                <div className="deposit-bottom">
                  <div>
                    <h3 className="subtitle">Recent Orders</h3>
                    <TableContainer
                      sx={{
                        margin: "20px 0",
                        borderRadius: "5px",
                        border: "1px solid var(--brd-new)",
                      }}
                    >
                      <Table
                        sx={{ minWidth: 650 }}
                        aria-label="simple table"
                        className="deposit-table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Date & Time</TableCell>
                            <TableCell>Fiat</TableCell>
                            <TableCell>Crypto</TableCell>
                            <TableCell>Fiat Amount</TableCell>
                            <TableCell>Crypto Amount</TableCell>
                            <TableCell>Status</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {instantBuySell?.docs?.length > 0 ? (
                            instantBuySell?.docs?.map((row, i) => (
                              <TableRow className="tr_row" key={i}>
                                <TableCell>
                                  {" "}
                                  {row?.createdAt?.split("T")[0]}{" "}
                                  {row?.createdAt
                                    ?.split("T")[1]
                                    ?.split(":")
                                    .slice(0, 2)
                                    .join(":")}{" "}
                                </TableCell>
                                <TableCell>
                                  <div className="d-flex align-items-center justi-center gap-10">
                                    <div>{row?.fiatCurrency}</div>
                                  </div>
                                </TableCell>
                                <TableCell>{row?.cryptoCurrency}</TableCell>
                                <TableCell>{row?.fiatAmount}</TableCell>
                                <TableCell>{row?.cryptoAmount}</TableCell>

                                <TableCell className={
                                  row.status === "order_complete" ? "green" : "red"
                                }>
                                  {row?.status === "order_failed" ? "Failed" : row?.status === "order_complete" ? "Completed" : row?.status === "order_cancelled" ? "Cancelled" : "Pending"}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow className="tr_row text-center">
                              <TableCell align="center" colSpan={7}>
                                <img src={nodata} alt="nodata" />
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <Box display="flex" justifyContent="center">
                        <Button
                          onClick={() => {
                            navigate("/history", {
                              state: {
                                index: 3,
                              },
                            });
                          }}
                        >
                          View more...
                        </Button>
                      </Box>
                      {/* <TablePagination
                        rowsPerPageOptions={[]}
                        component="div"
                        count={instantBuySell.totalDocs}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      /> */}
                    </TableContainer>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <Toaster />
      <Footernew />
    </div>
  );
}
